import { render, staticRenderFns } from "./UploadFiles.vue?vue&type=template&id=11f2d9d6&"
import script from "./UploadFiles.vue?vue&type=script&lang=ts&"
export * from "./UploadFiles.vue?vue&type=script&lang=ts&"
import style0 from "./UploadFiles.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports